import { render } from "./TransferenciaFerramentas.vue?vue&type=template&id=3ac5ce54"
import script from "./TransferenciaFerramentas.vue?vue&type=script&lang=js"
export * from "./TransferenciaFerramentas.vue?vue&type=script&lang=js"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__